import firebase from "firebase/compat/app";
import 'firebase/compat/auth';
import 'firebase/compat/firestore'
import 'firebase/compat/storage'
const firebaseConfig = {
  apiKey: "AIzaSyBUySyFLMXZ1CEpPZOAXrfNoSQ6iutsCcc",
  authDomain: "disneyplus-e30b8.firebaseapp.com",
  projectId: "disneyplus-e30b8",
  storageBucket: "disneyplus-e30b8.appspot.com",
  messagingSenderId: "260581812326",
  appId: "1:260581812326:web:4a91ff0ef910fd1c5465a7",
  measurementId: "G-0LLDWQS54G"
};

//Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig); //making our disney+ app a firebaseapp
const db = firebaseApp.firestore(); //creating the data base //this allows us to use the database we created in firebase site.
const auth = firebase.auth(); //creating authentications
const provider = new firebase.auth.GoogleAuthProvider(); //addong google emails for authenticationw when loggin in
const storage = firebase.storage(); //storing data for -> for this app it wil be movies/shows

export { auth, provider, storage};
export default db


/* Notes for auth: 

  auth has properties and methods that we can use to allow authentication services on our app. check firebase
  auth for more information

  we used the method "singinWithPopup(provider).then" which is a promise function that will create
  a popup screen with the providers information to the user to login. THis function doesnt save the user data
  but only shows it. For example if we console log the result of the promise we can display see the user
  information under user */